import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { parseUrl, urlSafeComponent } from '@mssgme/helpers';
import { __t } from '@mssgme/shared';
import { LinkBlank } from '@mssgme/ui';
import styles from './styles.scss';

// TODO: user helper func
function getHostname(str) {
    return str.replace(/^https?:\/\/([^/]+).*$/, '$1');
}

export class CardLinks extends Component {
    static propTypes = {
        links: PropTypes.array.isRequired,
        animated: PropTypes.bool,
        showActionSheet: PropTypes.func,
        website: PropTypes.object,
    };

    render() {
        const { links, animated, showActionSheet, website } = this.props;
        const isMenuBtn = links.length > 1;
        const isSingleCustomLink = links.length === 1;
        const urlObj = website && website.enabled && parseUrl(website.url);

        return (
            <div className={classNames(styles.root, styles.slideDown, animated ? styles.animated : null)}>
                <ul className={styles.linksList} id="card_list">
                    {!!urlObj && (
                        <li>
                            <LinkBlank
                                href={website.url}
                                data-id="website_link"
                                data-title={__t('website_link_title')}
                                data-element="custom-link"
                                data-event-name={urlSafeComponent(website.url)}
                            >
                                <div>
                                    {website.title || __t('visit_website')}
                                    <span className={styles.linkTip}>{getHostname(website.url)}</span>
                                </div>
                            </LinkBlank>
                        </li>
                    )}
                    {isMenuBtn && (
                        <li onClick={showActionSheet}>
                            <span>
                                <span className={styles.linkEllipsis}>{__t('menu_links')}</span>
                                <div className={styles.burger}>
                                    <div />
                                    <div />
                                    <div />
                                </div>
                            </span>
                        </li>
                    )}
                    {isSingleCustomLink &&
                        links.map(({ _id, redirectUrl, title, url }) => (
                            <li key={_id}>
                                <LinkBlank
                                    href={redirectUrl}
                                    data-id={_id}
                                    data-title={title}
                                    data-element="custom-link"
                                    data-event-name={urlSafeComponent(url)}
                                >
                                    <span className={styles.linkEllipsis}>{title}</span>
                                    {/*<LinkIcon className={styles.iconLink}/>*/}
                                </LinkBlank>
                            </li>
                        ))}
                </ul>
            </div>
        );
    }
}
